import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useListaCidadesService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { IListaCidades } from "../../../../../../../application/models";

export const RecorteListasCidade = () => {
  // State
  const { listasCidades } = useAppSelector((state) => state.listaCidades);
  const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao);

  // Use State
  const [selectedListasCidades, setSelectedListasCidades] = useState<IListaCidades[]>([]);

  // Hook
  const { setupListaCidades } = useListaCidadesService();
  const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService();

  useEffect(() => {
    const listasCidadesDoRedux = createRecorteExtracaoForm.fields.Filtros?.listasCidades || [];

    if (listasCidadesDoRedux.length > 0) {
      // Encontrar os objetos completos das listas de cidades baseado nos IDs
      const listasCompletas = (listasCidades || []).filter(lista =>
        listasCidadesDoRedux.includes(lista.IdVelesGeoListaCidade)
      );
      setSelectedListasCidades(listasCompletas);
    } else {
      setSelectedListasCidades([]);
    }
  }, [createRecorteExtracaoForm.fields.Filtros?.listasCidades, listasCidades]);

  // Filtra as opções para remover os itens já selecionados
  const filteredListasCidades = (listasCidades || []).filter((lista: IListaCidades) =>
    !selectedListasCidades.some((selected: IListaCidades) =>
      selected.IdVelesGeoListaCidade === lista.IdVelesGeoListaCidade
    )
  );

  const handleListasCidadesSelectionChange = (value: IListaCidades[]) => {
    setSelectedListasCidades(value);

    if (value.length > 0) {
      syncFilterWithForm({
        filtro: "listasCidades",
        value: value.map((lista) => lista.IdVelesGeoListaCidade),
        formType: 'create'
      });
    } else {
      removeFilterFromForm({
        filtro: "listasCidades",
        formType: 'create'
      });
    }
  };

  useEffect(() => {
    setupListaCidades();
  }, [setupListaCidades]);

  return (
    <>
      <Grid item xs={11} my={2}>
        <Autocomplete
          multiple
          id="listas-cidades-autocomplete"
          options={filteredListasCidades}
          getOptionLabel={(option) => option.Nome?.toUpperCase() || ""}
          isOptionEqualToValue={(option, value) =>
            option.IdVelesGeoListaCidade === value.IdVelesGeoListaCidade
          }
          value={selectedListasCidades}
          onChange={(_, value) => {
            handleListasCidadesSelectionChange(value);
          }}
          noOptionsText="Nenhuma lista encontrada"
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Listas de Cidades" />
          )}
          sx={{ px: 2 }}
        />
      </Grid>
    </>
  );
};